import BlanaceTable, { LocationHistoryMismatch } from 'components/table/balanceTable';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
  useParams, Link, useNavigate, useLocation
} from 'react-router-dom';
import Alert from 'components/alert';
import Header, { HeaderModifier } from 'components/header';
import Btn, { BtnModifier } from 'components/btn';
import ArrowLeftIcon from 'assets/icons/arrowLeft.svg';
import BalanceCheckDetailsTableWithReactQueryProvider from 'components/table/balancecheck/balanceCheckDetailsTable';
import BalanceCheckDetailsTableFilters from 'components/table/filters/balanceCheckDetailsTableFilters';
import { TooltipAlignEnum } from 'components/tooltip';

function BalanceCheckDetailsComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { name } = useParams();
  const [hasError, setHasError] = useState(false);
  const [currentMismatch, setCurrentMismatch] = useState<boolean | undefined>(undefined);
  const [userCurrencyMismatch, setUserCurrencyMismatch] = useState<boolean | undefined>(undefined);

  const [filters, setFilters] = useState('');

  return (
    <div className="ct_padding">
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <div className="ct_overviewDetailsHeader">
              <div className="ct_overviewDetailsHeader-main">
                <Header
                  headline={name ? `${name} ${t('Balance', { ns: 'overview' })}` : `${t('Balance', { ns: 'overview' })}`}
                  modifiers={[
                    HeaderModifier.OLD, HeaderModifier.ONLY_TITLE_MARGIN,
                  ]}
                />
              </div>
              <div className="ct_overviewHeader-aside">
                <Btn
                  onClick={() => {
                    const originalCurrencyMismatch = (location.state as LocationHistoryMismatch !== undefined)
                    && (location.state as LocationHistoryMismatch !== null)
                    && ((location.state as LocationHistoryMismatch).dataCurrency !== undefined)
                    && ((location.state as LocationHistoryMismatch).dataCurrency !== null)
                      ? (location.state as LocationHistoryMismatch).dataCurrency! : true;

                    const changed = originalCurrencyMismatch !== userCurrencyMismatch;
                    navigate('/balancecheck', {
                        state: { data: currentMismatch, dataCurrency: userCurrencyMismatch, tableChanged: changed },
                    });
                  }}
                  type="primary"
                  text={t('Back to Overview', { ns: 'overview' })}
                  icon={<ArrowLeftIcon />}
                  modifier={[BtnModifier.OLD, BtnModifier.NICE_BUTTON_CLASSIC]}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_overviewDetailsHeader-fullSide">
              <BalanceCheckDetailsTableFilters
                ignoreSmallMismatchesProp={false}
                ignoreUserCurrencyMismatchesProp={(location.state as LocationHistoryMismatch !== undefined)
                  && (location.state as LocationHistoryMismatch !== null)
                  && ((location.state as LocationHistoryMismatch).dataCurrency !== undefined)
                  && ((location.state as LocationHistoryMismatch).dataCurrency !== null)
                  ? (location.state as LocationHistoryMismatch).dataCurrency! : true}
                onSmallMismatchUpdate={(value: boolean) => {} }
                onUserCurrencyMismatchUpdate={(value: boolean) => {
                  if (setUserCurrencyMismatch) setUserCurrencyMismatch(value);
                }}
                onFitlerCB={(value: string) => setFilters(value)} 
                onWarningsUpdate={(value: boolean) => {}}
                onShowReportedBalanceUpdate={(value: boolean) => {}}
                showWarningsProp={false}
                showReportedBalancesProp={false}
                useLocalSearch={false} 
                onGlobalFilterUpdate={() => {}}
                disabled={false}
                leftAlignedSearch={false}
                tooltipAlignment={TooltipAlignEnum.RIGHT}
              />
            {!!hasError && (
            <Alert type="error" hasArrow={false} title="Error">
              <>
                {t(
                  'No item found using this name.',
                  { ns: 'overview' },
                )}
                {' '}
                <Link
                  to={{
                    pathname: '/import',
                  }}
                  state={{
                    data: currentMismatch,
                    dataCurrency: userCurrencyMismatch,
                  }}
                  className="ct_link _bold"
                >
                  {t('Start importing your trades here', { ns: 'overview' })}
                </Link>
                .
              </>
            </Alert>
            )}
            {!hasError && (
              <BalanceCheckDetailsTableWithReactQueryProvider
                filters={filters}
                onErrorCB={() => setHasError(true)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalanceCheckDetailsComponent;
